export default "__VITE_ASSET__CRhDFtwW__"